module.exports = __webpack_public_path__ + "img/turbo_on.62437570.png";